export default __webpack_public_path__ + "ec8d2f0991254b50a3768a39594aba2f.png";